<template>
  <div v-if="!hideValue" class="flex items-center gap-1.5">
    <PeriodDiffIcon :class="`transform ${polarityClass}`" :style="getPeriodDiffStyle" />
    <BaseText type="label" size="sm" :class="polarityClass">
      {{ loading ? '--' : changeValueFormatted }}
    </BaseText>
    <BaseText size="sm" class="text-text-normal truncate">
      {{ periodText }}
    </BaseText>
  </div>
  <div v-else class="flex items-center gap-1.5 text-text-subdued">
    <PeriodDiffIcon />
    <BaseText type="label" size="sm">
      --
    </BaseText>
    <BaseText size="sm" class="truncate">
      {{ periodText }}
    </BaseText>
  </div>
</template>

<script>
import PeriodDiffIcon from '../globals/Icons/LensIcons/PeriodDiffIcon.vue'

export default {
  name: 'IntegerChangeIndicator',
  components: {
    PeriodDiffIcon
  },
  props: {
    changeValue: {
      type: Number,
      default: () => 0
    },
    periodText: {
      type: String,
      default: () => 'Previous period'
    },
    direction: {
      type: String,
      default: () => 'positive'
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    hideValue: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    changeValueFormatted () {
      return this.changeValue >= 0 ? `+${this.changeValue}` : this.changeValue
    },
    polarityClass () {
      return this.direction === 'positive'
        ? this.changeValue > 0
          ? 'text-secondary-green-200'
          : 'text-text-muted'
        : this.changeValue >= 0
          ? 'text-text-muted'
          : 'text-secondary-green-200'
    },
    getPeriodDiffStyle () {
      return this.changeValue >= 0 ? '' : 'transform: scale(1,-1)'
    }
  }
}
</script>